module.exports = __webpack_public_path__ + "media/flags/012-uk-41ecfa17.svg";